import React from "react";

export const AnimatedBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0" style={{ transform: 'translateZ(0)', willChange: 'transform' }}>
      {/* Large floating gradient orbs with smooth movement and pulse */}
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-purple-500/20 dark:bg-purple-500/10 rounded-full blur-3xl animate-float-slow animate-pulse-slow" style={{ backfaceVisibility: 'hidden' }} />
      <div className="absolute top-1/2 -left-40 w-[550px] h-[550px] bg-pink-500/20 dark:bg-pink-500/10 rounded-full blur-3xl animate-float-medium animate-pulse-medium" style={{ backfaceVisibility: 'hidden' }} />
      <div className="absolute -bottom-40 right-1/4 w-[500px] h-[500px] bg-blue-500/20 dark:bg-blue-500/10 rounded-full blur-3xl animate-float-fast animate-pulse-fast" style={{ backfaceVisibility: 'hidden' }} />
      <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-indigo-500/15 dark:bg-indigo-500/8 rounded-full blur-3xl animate-float-reverse animate-pulse-slow" style={{ backfaceVisibility: 'hidden' }} />
      
      {/* Additional medium orbs */}
      <div className="absolute top-1/3 right-1/3 w-80 h-80 bg-cyan-500/15 dark:bg-cyan-500/8 rounded-full blur-3xl animate-float-diagonal" style={{ backfaceVisibility: 'hidden' }} />
      <div className="absolute bottom-1/4 left-1/4 w-72 h-72 bg-fuchsia-500/15 dark:bg-fuchsia-500/8 rounded-full blur-3xl animate-float-circular" style={{ backfaceVisibility: 'hidden' }} />
      
      {/* Gradient mesh overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 via-transparent to-pink-500/5 dark:from-purple-500/3 dark:to-pink-500/3 animate-gradient-shift" style={{ backfaceVisibility: 'hidden' }} />

      {/* Floating particles with varied sizes */}
      {[...Array(30)].map((_, i) => {
        const size = Math.random() > 0.7 ? 2 : 1;
        const colors = [
          'bg-purple-400/40 dark:bg-purple-400/25',
          'bg-pink-400/40 dark:bg-pink-400/25',
          'bg-blue-400/40 dark:bg-blue-400/25',
          'bg-indigo-400/40 dark:bg-indigo-400/25',
          'bg-cyan-400/40 dark:bg-cyan-400/25',
        ];
        const color = colors[i % colors.length];
        
        return (
          <div
            key={i}
            className={`absolute w-${size} h-${size} ${color} rounded-full animate-particle`}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 15}s`,
              animationDuration: `${12 + Math.random() * 15}s`,
              backfaceVisibility: 'hidden',
            }}
          />
        );
      })}

      {/* Floating dots with different animation */}
      {[...Array(15)].map((_, i) => (
        <div
          key={`dot-${i}`}
          className="absolute w-1.5 h-1.5 bg-white/20 dark:bg-white/10 rounded-full animate-float-dot"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 10}s`,
            animationDuration: `${8 + Math.random() * 8}s`,
            backfaceVisibility: 'hidden',
          }}
        />
      ))}
    </div>
  );
};
